export default async function SignUpApi(senddata) {
    let url = window.UserService + `/api/Users/AddUser`
    let response = {}

    let head = {
        "Content-Type": "application/json",
        'accept': '*/*'
    }
    response = await fetch(url, {
        method: "POST",
        headers: head,
        body: JSON.stringify(senddata)
    }).then(res => res.json()).then(response)
    return response;
}